import { useEffect, useState } from 'react';
import Style from './style.module.css';
import { PlusIcon } from 'lucide-react';
import { Alert, Snackbar } from '@mui/material';
import { useApiCall } from '../../../../component/custom-hooks/api-call';
import DataNotFound from '../../../../component/ui/loader/data-not-found';
import InnerLoader from '../../../../component/ui/loader/inner-loader';
import { Table, TableBody, TableCard, TableCell, TableHead, TableHeaderWrap, TableRow } from '../../../../component/table/table-layout';
import Tooltip from '../../../../component/ui/tooltip';
import FilterFunnel01Icon from '../../../../component/icons/filter-funnel-01';
import DynamicFilter from '../../../../component/table/filter-table/dynamic-filter';
import StatusChip from '../../../../component/ui/chip/status';
import NewEditIcon from '../../../../component/icons/action-edit-icon';
import { TitleHeading } from '../../../../component/ui/layout';
import BrandModal from '../../../../component/popup/add-update-brand';

const BrandOrganizationList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [list, setList] = useState([]);
  const [alertData, setAlertData] = useState({ isShow: false })
  const [showModal, setShowModal] = useState(false)
  const [currentList, setCurrentList] = useState({});
  const [filterReturn, setFilterReturn] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);

  const handleClose = () => {
    setAlertData({ isShow: false })
  }

  const apiCall = useApiCall()

  useEffect(() => {
    getData();
  }, []);

  const getData = async (filter = filterReturn) => {
    setIsLoading(true)
    let extraUrl = `?test=test`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`
    }
    try {
      const res = await apiCall({ method: 'get', url: `get-brands-list${extraUrl}` });
      setList(res.data);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  }

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message })
    getData({});
    setShowModal(false)
  }

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message })
  }

  const filterModalData = [
    {
      name: "status",
      label: "Status",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [{ label: "Active", val: "active" }, { label: "In Active", val: "inactive" }],
      dropdownKey: "label",
      dropdownVal: "val"
    },
    { name: "head_name", label: "Head Name", options: ["contains"], selectedOpt: "contains", value: "", type: "text" },
    { name: "department", label: "Department Name", options: ["contains"], selectedOpt: "contains", value: "", type: "text" }
  ]

  return (
    <>
      <div className={Style.leaveMainPage}>
        <div className={"flex items-center justify-between"}>
          <div className={Style.empDirectory_header_left}>
            <TitleHeading title={`Brands`} />
          </div>

          <div className={Style.empDirectory_header_right}>
            <div className="flex items-center gap-2">
              <div className={Style.bpfl_action} onClick={() => { setShowModal(true) }}>
                <Tooltip content={"Add Brand"} position={'left center'} className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}>
                  <div className={Style.icon}>
                    <PlusIcon size={'1em'} />
                  </div>
                </Tooltip>
              </div>

              {/* <Tooltip className={Style.bpfl_actionItems} content={"Table Filter"} position={'left center'}>
                <div className={`${Style.bpfl_actionBtn} ${(filterReturn?.length) ? Style.active : null}`} onClick={() => { setShowModalFilterTable(true); }}>
                  <div className={Style.icon}>
                    <FilterFunnel01Icon />
                  </div>
                </div>
              </Tooltip> */}
            </div>
          </div>
        </div>

        <div className={Style.leaveTeamTabPage}>
          {isLoading ?
            <InnerLoader />
            :
            (!list?.length) ?
              <div className="w-full h-full flex items-center justify-center">
                <DataNotFound title={"Department's"} />
              </div>
              :
              <>
                <TableCard>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell header sticky><TableHeaderWrap><span>Name</span></TableHeaderWrap></TableCell>
                        {/* <TableCell header><TableHeaderWrap><span>Name</span></TableHeaderWrap></TableCell> */}
                        <TableCell header><TableHeaderWrap><span>Url</span></TableHeaderWrap></TableCell>
                        <TableCell header><TableHeaderWrap><span>Status</span></TableHeaderWrap></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {list?.map((eachList, index) => {
                        return (
                          <TableRow key={`${index}`}>
                            <TableCell sticky className={"w-[33%]"}>

                              <div className={`${Style.tableActionArea}`}>
                                <div>
                                  {eachList?.name ?? "--"}
                                </div>

                                <div className={Style.tableActionAreaBtnGrpup}>
                                  <div
                                    className={
                                      "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                    }
                                    onClick={() => { setCurrentList(eachList); setShowModal(true) }}
                                  >
                                    <div
                                      className={Style.icon}
                                      style={{ color: "#FF9500" }}
                                    >
                                      <NewEditIcon className="h-4.5 w-4.5" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell className={"w-[33%]"}>{eachList?.url ?? "--"}</TableCell>
                            {/* <TableCell>{eachList?.departmentmail || "-"}</TableCell>
                            <TableCell>{eachList?.employees_count}</TableCell> */}
                            <TableCell className={"w-[33%]"}>
                              {
                                (eachList?.is_active == 1) ? (
                                  <StatusChip color="green">Active</StatusChip>
                                ) : (
                                  <StatusChip color="red">In-Active</StatusChip>
                                )
                              }
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableCard>
              </>
          }
        </div>
      </div>

      {showModalFilterTable &&
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters) => {
            getData(filters);
            setShowModalFilterTable(false)
            setFilterReturn(filters);
          }}
          // saveFilter={saveFilter}
          // apiUrl="department-list"
          saveFilterOff
        />
      }

      {showModal &&
        <BrandModal onClose={() => { setShowModal(false); setCurrentList({}) }} onError={onError} onSubmit={onSuccess} currentList={currentList} />
      }

      <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  )
}

export default BrandOrganizationList